import { AppNotification } from '@/types/appNotification';
import { MessagePayload } from 'firebase/messaging';

const MAX_TITLE_LENGTH = 100;
const MAX_BODY_LENGTH = 1000;

const str = (val: string | object | undefined): string =>
    typeof val === 'string' ? val : '';

export function normalizeNotification(
    payload: MessagePayload,
): AppNotification | null {
    try {
        const data = payload?.data ?? {};
        const notification = payload?.notification ?? {};

        const rawTitle = notification?.title || str(data?.title) || '';
        const rawBody = notification?.body || str(data?.body) || '';

        const title = rawTitle.trim().slice(0, MAX_TITLE_LENGTH);
        const body = rawBody.trim().slice(0, MAX_BODY_LENGTH);

        if (!title && !body) return null;

        return {
            id: payload?.messageId || str(data?.id) || String(Date.now()),
            title,
            body,
            image: notification?.image || str(data?.image) || undefined,
            type: str(data?.type) || undefined,
            is_read: false,
            created_at: Date.now(),
            data: {
                deeplink: str(data?.deeplink) || undefined,
                entity_id: str(data?.entity_id) || undefined,
            },
        };
    } catch (error) {
        console.warn('[normalizeNotification] Failed to parse:', error);
        return null;
    }
}